import { Box, MenuItem } from '@mui/material';
import {
  HeaderFilterBox,
  CustomTextField,
  CustomAutoComplete,
  HorizontalForm,
} from '../../../common/components';
import {
  COST_AREA_OPTIONS,
  COST_BEHAVIOR_OPTIONS,
  COST_TRACEABILITY_OPTIONS,
} from '../../constants/financeConstants';

const PaymentOrdersHeader = ({
  filters,
  searchTerm,
  legalEntities = [],
  statusOptions = [],
  onFilterChange,
  onSearchChange,
}) => (
  <>
    <HeaderFilterBox>
      <HorizontalForm variant="twoRows">
        <Box>
          <CustomTextField
            label="Desde"
            type="date"
            name="start_date"
            value={filters.start_date}
            onChange={onFilterChange}
            shrinkLabel
            size="medium"
            sx={{ maxWidth: 240, mr: 1.5 }}
          />
          <CustomTextField
            label="Hasta"
            type="date"
            name="end_date"
            value={filters.end_date}
            onChange={onFilterChange}
            shrinkLabel
            size="medium"
            sx={{ maxWidth: 240, mr: 1.5  }}
          />
          <CustomTextField
            placeholder="Buscar por beneficiario, observación o número"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            size="medium"
            sx={{ maxWidth: 580 }}
          />
        </Box>
        <Box>
          <CustomAutoComplete
            label="Beneficiario"
            name="uuid_legal_entity"
            value={filters.uuid_legal_entity}
            onChange={onFilterChange}
            size="medium"
            sx={{ maxWidth: 240, mr: 1.5  }}
          >
            <MenuItem value="">Todos</MenuItem>
            {legalEntities.map((entity) => (
              <MenuItem key={entity.uuid} value={entity.uuid}>
                {entity.legal_business_name || entity.company || entity.cuit}
              </MenuItem>
            ))}
          </CustomAutoComplete>

          <CustomAutoComplete
            label="Estado"
            name="status"
            value={filters.status}
            onChange={onFilterChange}
            size="medium"
            sx={{ maxWidth: 240 }}
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomAutoComplete>
          <CustomAutoComplete
            label="Fijo/Variable"
            name="cost_behavior"
            value={filters.cost_behavior}
            onChange={onFilterChange}
            size="medium"
            sx={{ maxWidth: 200, ml: 1.5 }}
          >
            <MenuItem value="">Todos</MenuItem>
            {COST_BEHAVIOR_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </CustomAutoComplete>
          <CustomAutoComplete
            label="Directo/Indirecto"
            name="cost_traceability"
            value={filters.cost_traceability}
            onChange={onFilterChange}
            size="medium"
            sx={{ maxWidth: 200, ml: 1.5 }}
          >
            <MenuItem value="">Todos</MenuItem>
            {COST_TRACEABILITY_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </CustomAutoComplete>
          <CustomAutoComplete
            label="Área"
            name="cost_area"
            value={filters.cost_area}
            onChange={onFilterChange}
            size="medium"
            sx={{ maxWidth: 200, ml: 1.5 }}
          >
            <MenuItem value="">Todas</MenuItem>
            {COST_AREA_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </CustomAutoComplete>
        </Box>
      </HorizontalForm>
    </HeaderFilterBox>
  </>
);

export default PaymentOrdersHeader;
